module.exports = __webpack_public_path__ + "capital-provider-cover.ab84f48.png";